import { render, staticRenderFns } from "./CreativeIndex.vue?vue&type=template&id=36891854&"
import script from "./CreativeIndex.vue?vue&type=script&lang=js&"
export * from "./CreativeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports